import { useMemo } from 'react';
import { LifeCover } from '@app/domain/model/eshop/life/LifeCover';
import { Coverage } from '@app/domain/model/Coverage';
import { SelectedCover } from '@app/domain/model/eshop/life/SelectedCover';
import { getATDBasedMinimums } from '@app/app/esales/life/_sections/steps/CustomCoverSelectionStep/getATDBasedMinimums';

const CHOICE_BUTTON_MAX_OPTIONS = 3;
const RANGE_SLIDER_STEP = 1000;

export function useCoverConfigs(covers: LifeCover[], selectedCovers: SelectedCover[]) {
    return useMemo(() => {
        const atdSelectedCover = selectedCovers.find(sc => sc.code === Coverage.TemporaryDisabilityByAccident);
        const isATDEnabled = atdSelectedCover?.enabled ?? false;
        const atdValue = atdSelectedCover?.value ?? 0;

        const atdMinimums = isATDEnabled ? getATDBasedMinimums(atdValue) : null;

        return covers.map(cover => {
            const selectedCover = selectedCovers.find(selectedCover => selectedCover.code === cover.code);

            const hasOptions = cover.options && cover.options.length > 0;
            const canUseChoiceButtons =
                hasOptions && cover.options.length >= 1 && cover.options.length <= CHOICE_BUTTON_MAX_OPTIONS;

            let min = cover.min;
            if (atdMinimums) {
                if (cover.code === Coverage.LifeInsurance) {
                    min = Math.max(cover.min, atdMinimums.diMin);
                } else if (cover.code === Coverage.DisabilityByAccident) {
                    min = Math.max(cover.min, atdMinimums.apdMin);
                }
            }

            const max = cover.max;
            const step = RANGE_SLIDER_STEP;

            const isLifeInsurance = cover.code === Coverage.LifeInsurance;

            return {
                cover,
                selectedCover,
                min,
                max,
                step,
                isSwitchDisabled: isLifeInsurance,
                canUseChoiceButtons,
                options: canUseChoiceButtons ? cover.options : [],
            };
        });
    }, [covers, selectedCovers]);
}
